export default __webpack_public_path__ + "static/media/steak.6e2d01e0.jpg";